export default {
  quick_links: {
    title: 'Hızlı Bağlantılar',
    developers: 'Müteahhitler',
    agencies: 'Ajanslar',
    properties: 'İlanlar',
  },
  company: {
    title: 'Şirket Hakkında',
    about_services: 'Hizmet Hakkında',
    news: 'Haberler',
    statistic: 'İstatistik',
  },
  support: {
    title: 'Destek',
  },
  get_in_touch: 'Bizimle İletişime Geçin',
  email: 'info(at)estimator24.com',
  phone: '+41762378017',
  copyright: 'Estimator24.com'
}
